import { Box, Grid, TextField, Button, Typography } from '@mui/material'
import { FormEvent, useState } from 'react'
import { useAppDispatch } from '../../redux/hooks'
import { AppAlert } from '../../components/AppAlerts/AppAlerts'
import { addAlertWithTimeout } from '../../redux/features/alerts/alertsHelpers'
import { getAuthService } from '../../services/authService'

export const ConfirmAccount = () => {

    const dispatch = useAppDispatch()
    const [username, setUsername] = useState<string>('')
    const [password, setPassword] = useState<string>('')
    const [firstName, setFirstName] = useState<string>('')
    const [lastName, setLastName] = useState<string>('')
    const [usernameError, setUsernameError] = useState<string>('')
    const [passwordError, setPasswordError] = useState<string>('')
    const [firstNameError, setFirstNameError] = useState<string>('')
    const [lastNameError, setLastNameError] = useState<string>('')
    const [processing, setProcessing] = useState<boolean>(false)

    const url = new URL(window.location.href)
    const searchParams = url.searchParams
    const token = searchParams.get('token')

    const fieldBlank = !username || !password || !firstName || !lastName
    const hasError = !!usernameError || !!passwordError || !!firstNameError || !!lastNameError
    const submitDisabled = processing || fieldBlank || hasError

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        confirmAccount()
    }

    const handleSubmitClick = () => {
        confirmAccount()
    }

    const confirmAccount = async () => {
        if (validatePassword() || !username || !password || processing) {
            return
        }
        setProcessing(true)
        try {
            const authService = await getAuthService()
            await authService.confirmAccount(username, password, token ?? '', firstName, lastName)
                .then(() => {
                    console.log('Account confirmed!')
                })
        } catch (err) {
            // const error = err as ResponseError
            // const res = error.response
            // const text = await res.text().catch(() => null)
            const alert = new AppAlert('error', 'Something went wrong, try again later')
            addAlertWithTimeout(dispatch, alert)
            console.error('Error confirming account:', err)
        }
        setProcessing(false)
    }

    const handleUsernameFocus = () => {
        setUsernameError('')
    }

    const handlePasswordFocus = () => {
        setPasswordError('')
    }

    const handleFirstNameFocus = () => {
        setFirstNameError('')
    }

    const handleLastNameFocus = () => {
        setLastNameError('')
    }

    const handleUsernameBlur = () => {

    }

    const handlePasswordBlur = () => {
        setPasswordError(validatePassword())
    }

    const handleFirstNameBlur = () => {
        if (!firstName) {
            setFirstNameError('First name is required')
        }
    }

    const handleLastNameBlur = () => {
        if (!lastName) {
            setLastNameError('Last name is required')
        }
    }

    const validatePassword = () => {
        if (password.length < 8) {
            return 'Password must be at least 8 characters long'
        }
        if (!(/[A-Z]/.test(password))) {
            return 'Password must contain an uppercase letter'
        }
        if (!(/[a-z]/.test(password))) {
            return 'Password must contain a lowercase letter'
        }
        if (!(/[0-9]/.test(password))) {
            return 'Password must contain a number'
        }
        if (!(/(\^|\$|\*|\.|\[|\]|\{|\}|\(|\)|\?|-|"|!|@|#|%|&|\/|\\|,|>|<|'|:|;|\||_|~|`|\+|=)/.test(password))) {
            return 'Password must contain a special character'
        }
        return ''
    }

    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
        }}>
            <Typography variant='h3' sx={{
                textAlign: 'center',
                mt: 3,
                fontSize: '1.5rem',
                fontWeight: 200,
            }}>
                Confirm Account
            </Typography>
            <Box component='form' onSubmit={handleSubmit} sx={{ mt: 3 }} maxWidth='md' width={'100%'}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            required
                            fullWidth
                            error={!!usernameError}
                            helperText={usernameError}
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            onFocus={handleUsernameFocus}
                            onBlur={handleUsernameBlur}
                            label='Username'
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            required
                            fullWidth
                            value={password}
                            error={!!passwordError}
                            helperText={passwordError}
                            onFocus={handlePasswordFocus}
                            onBlur={handlePasswordBlur}
                            onChange={(e) => setPassword(e.target.value)}
                            type='password'
                            label='Password'
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            required
                            fullWidth
                            error={!!firstNameError}
                            helperText={firstNameError}
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            onFocus={handleFirstNameFocus}
                            onBlur={handleFirstNameBlur}
                            label='First Name'
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <TextField
                            required
                            fullWidth
                            value={lastName}
                            error={!!lastNameError}
                            helperText={lastNameError}
                            onFocus={handleLastNameFocus}
                            onBlur={handleLastNameBlur}
                            onChange={(e) => setLastName(e.target.value)}
                            label='Last Name'
                        />
                    </Grid>
                </Grid>
                <Button disabled={submitDisabled} type='submit' fullWidth variant="contained" color="primary" sx={{ mt: 2, mb: 2 }} onClick={handleSubmitClick}>Confirm Account</Button>
            </Box>
        </Box>
    )
}